export default "https://cdn-static.gokick.com/assets/1d764bbda6f1db3d5ed96a1ece7edd078534d524/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";